import type { ParticipationOverviewPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { html } from 'lit';
import { defaultGetDropdownActions, defaultParticipationOverviewPlugin } from './default.js';

export const icsrmParticipationOverviewPlugin: ParticipationOverviewPlugin = {
  id: 'participation-overview::icsrm',
  type: 'participation-overview',
  getDropdownItemActions: defaultGetDropdownActions,
  getColumnDefinitions: (
    host,
    product,
    coloring,
    paymentActive,
    participationState,
    extraColumns,
    operation,
    filter,
    suspensionHandler,
    deSuspensionHandler,
  ) => {
    const customColumns = defaultParticipationOverviewPlugin.getColumnDefinitions(
      host,
      product,
      coloring,
      paymentActive,
      participationState,
      extraColumns,
      operation,
      filter,
      suspensionHandler,
      deSuspensionHandler,
    );
    const herkunftslandColumnDefinition = {
      columnName: 'Herkunftsland',
      fieldName: 'buyer.stammdaten.countryOfBirth',
      isSortable: true,
      renderItem: instance => html` <tr-text>${instance.buyer?.stammdaten?.countryOfBirth ?? '-'}</tr-text>`,
    };

    // insert herkunftsland column
    customColumns.splice(4, 0, herkunftslandColumnDefinition);

    return customColumns;
  },

  getCSVFieldsForExport: async stammdatenFields => {
    const fields = await defaultParticipationOverviewPlugin.getCSVFieldsForExport(stammdatenFields);
    const nachNameIndex = fields.findIndex(field => (field as any).input === 'Nachname');
    const countryField = { input: 'Land', output: 'stammdaten.countryOfBirth' };
    fields.splice(nachNameIndex + 1, 0, countryField); // insert country field after Nachname
    return fields;
  },
};
